import { render } from "./PracticeTestAdmin.vue?vue&type=template&id=2eb6ad22&scoped=true"
import script from "./PracticeTestAdmin.vue?vue&type=script&lang=js"
export * from "./PracticeTestAdmin.vue?vue&type=script&lang=js"

import "./PracticeTestAdmin.vue?vue&type=style&index=0&id=2eb6ad22&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb6ad22"]])

export default __exports__